module.exports = __webpack_public_path__ + "img/lk-menu-payment-method.a72d6560.svg";